module.exports = __webpack_public_path__ + "static/img/EChars.fcbf66c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/EChars.jpg
// module id = z1PJ
// module chunks = 0